/* =============================================
   MON RUE — THEME JS (Clean version)
   ============================================= */

(function () {
  'use strict';

  /* ------------------------------------------
     CUSTOM CURSOR (desktop only)
  ------------------------------------------ */
  var cursor = document.getElementById('cursor');
  var cursorRing = document.getElementById('cursorRing');

  if (cursor && cursorRing && window.matchMedia('(pointer: fine)').matches) {
    var mx = 0, my = 0, rx = 0, ry = 0;

    document.addEventListener('mousemove', function(e) {
      mx = e.clientX;
      my = e.clientY;
      cursor.style.left = mx + 'px';
      cursor.style.top  = my + 'px';
    });

    function animateCursorRing() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      cursorRing.style.left = rx + 'px';
      cursorRing.style.top  = ry + 'px';
      requestAnimationFrame(animateCursorRing);
    }
    animateCursorRing();
  }

  /* ------------------------------------------
     SCROLL REVEAL
  ------------------------------------------ */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    reveals.forEach(function(el) { revealObserver.observe(el); });
  } else {
    reveals.forEach(function(el) { el.classList.add('visible'); });
  }

  /* ------------------------------------------
     WISHLIST TOGGLE
  ------------------------------------------ */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.bs-card__wishlist, .col-card__wish');
    if (!btn) return;
    var isActive = btn.classList.toggle('active');
    btn.textContent = isActive ? '♥' : '♡';
    btn.style.color = isActive ? '#6B2737' : '';
  });

  /* ------------------------------------------
     CART COUNT UPDATE HELPER
  ------------------------------------------ */
  window.updateCartCount = function(count) {
    document.querySelectorAll('.mr-cart-count, .cart-count').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  };

  /* ------------------------------------------
     CART DRAWER QTY BUTTONS
  ------------------------------------------ */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.qty-btn');
    if (!btn) return;
    var key    = btn.dataset.key;
    var action = btn.dataset.action;
    var qtyEl  = btn.parentElement.querySelector('span');
    var current = parseInt(qtyEl ? qtyEl.textContent : 1) || 1;
    var newQty  = action === 'increase' ? current + 1 : Math.max(0, current - 1);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      window.updateCartCount(cart.item_count);
      if (newQty === 0) {
        var item = btn.closest('.cart-item');
        if (item) item.remove();
      } else if (qtyEl) {
        qtyEl.textContent = newQty;
      }
      var subtotal = document.querySelector('.cart-subtotal__amount');
      if (subtotal) {
        subtotal.textContent = (cart.total_price / 100).toLocaleString('id-ID', {
          style: 'currency', currency: 'IDR'
        });
      }
    });
  });

  /* ------------------------------------------ a
     SMOOTH ANCHOR SCROLL
  ------------------------------------------ */
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ------------------------------------------
     NEWSLETTER FORM FEEDBACK
  ------------------------------------------ */
  var nlForm = document.querySelector('.newsletter__form');
  if (nlForm) {
    nlForm.addEventListener('submit', function() {
      var btn = nlForm.querySelector('.newsletter__submit');
      if (btn) {
        setTimeout(function() {
          btn.textContent = 'Welcome to Mon Rue ✦';
          btn.style.background = '#6B2737';
          btn.style.borderColor = '#6B2737';
        }, 200);
      }
    });
  }

})();